import { useEffect } from "react";

const DryerRepair = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#222222] text-white">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        {/* Image container with mobile optimization */}
        <div className="h-[40vh] md:h-screen relative">
          <img
            src="/lovable-uploads/c60296eb-c347-41fb-bd80-596675c832c1.png"
            alt="Dryer repair service"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-8 overflow-y-auto">
          <h1 className="text-4xl font-bold mb-8 text-accent">Dryer Repair Services</h1>
          <div className="space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-accent-light mb-4">Professional Dryer Repair in GTA</h2>
              <p className="text-gray-300 mb-4">
                We specialize in comprehensive dryer repair services for all major brands and models. Our expert technicians
                are trained to diagnose and fix any dryer-related issues quickly and efficiently.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Services We Offer:</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Heating element replacement</li>
                <li>Thermostat and sensor repair</li>
                <li>Belt and drum maintenance</li>
                <li>Vent cleaning and maintenance</li>
                <li>Control panel repairs</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Our Advantages</h3>
              <ul className="space-y-4 text-gray-300">
                <li>✓ Fast response times</li>
                <li>✓ Expert technicians</li>
                <li>✓ Quality replacement parts</li>
                <li>✓ Affordable rates</li>
                <li>✓ 24/7 emergency service</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-semibold text-accent-light mb-3">Common Dryer Problems We Solve</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-300">
                <div>• Not heating properly</div>
                <div>• Strange noises</div>
                <div>• Won't start</div>
                <div>• Long drying times</div>
                <div>• Overheating issues</div>
                <div>• Drum not spinning</div>
              </div>
            </section>

            <div className="mt-8">
              <a
                href="tel:416-805-5075"
                className="bg-accent hover:bg-accent-hover text-white px-6 py-3 rounded-lg inline-block transition-colors"
              >
                Call Now for Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DryerRepair;
